import Link from "next/link";

export default function SectionHeader({
  title,
  subtitle,
  id,
  action,
  sectionClassName,
  dataScrollOffset,
  children,
}) {
  return (
    <section
      id={id}
      data-scroll-offset={dataScrollOffset}
      className={
        sectionClassName ||
        "rounded-3xl bg-white px-5 py-8 ring-1 ring-slate-200/70 sm:px-6 sm:py-12"
      }
    >
      <div className="flex flex-col items-center gap-4 text-center sm:gap-6">
        <div>
          <h2
            className={
              "text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl"
            }
          >
            {title}
          </h2>
          <p className={"mt-2 text-sm leading-6 text-slate-600 sm:text-base"}>
            {subtitle}
          </p>
        </div>
        {action && (
          <Link
            href={action.href}
            className="text-sm font-semibold text-slate-700 hover:text-slate-900"
          >
            {action.label}
          </Link>
        )}
      </div>
      {children}
    </section>
  );
}
